import { INQUIRY_STORE } from '@/store/constants'
import { RootState } from '@/store/store.type'
import { GetterTree } from 'vuex'
import { InquiryStateTypes } from '.'

export const getters: GetterTree<any, RootState> = {
  [INQUIRY_STORE.GETTERS.INQUIRY_CATEGORIES]: (state: InquiryStateTypes): any => state.inquiryCategories,
  [INQUIRY_STORE.GETTERS.INQUIRY_DATA]: (state: InquiryStateTypes): any => state.inquiryData,
}
